module.exports = __webpack_public_path__ + "img/poe.39cc01ba.svg";